export default __webpack_public_path__ + "assets/images/0ce050cc4d313470af9ff940b90c8d23.svg";